module.exports = __webpack_public_path__ + "static/media/sonic.29dd5da4.jpeg";